import React from 'react';
import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import useStyles from './styles';

const Button = (props: any) => {
  const styles = useStyles();
  const {
    className = '',
    buttonType = '',
    label = '',
    loading = false,
    ...remainProps
  } = props;

  const mainClass = styles.button;

  return (
    <button
      className={`${mainClass} ${className} ${mainClass}--${buttonType}`}
      {...remainProps}
    >
      {label}
      {loading && (
        <span className={`${mainClass}__loading`}>
          <CircularProgress size={16} />
        </span>
      )}
    </button>
  );
};

export default Button;